import Image from "next/image"
import { useState, useEffect } from "react"

import MissingImage from "@/public/images/image-missing.png"

const ImageWrapper = props => {
  const { src = MissingImage, alt = "", ...restProps } = props || {}
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    if (isError) setIsError(false)
  }, [src])

  return (
    <Image
      {...restProps}
      blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc1IiBoZWlnaHQ9IjIyOSIgdmlld0JveD0iMCAwIDE3NSAyMjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxNzUiIGhlaWdodD0iMjI5IiByeD0iMTYiIGZpbGw9IiM4MDgwODAiIGZpbGwtb3BhY2l0eT0iMC41NSIvPgo8L3N2Zz4K"
      src={isError ? MissingImage : src}
      onError={() => setIsError(true)}
      alt={alt}
    />
  )
}

export default ImageWrapper
